import { useRef } from 'react';
import classNames from 'classnames';

import type { FC } from 'react';

import * as styles from './MobileCard.module.scss';

interface MobileCardProps {
  imageUrl?: string;
  name: string;
  isSelected: boolean;
}

export const MobileCard: FC<MobileCardProps> = ({
  imageUrl,
  name,
  isSelected,
}) => {
  const ref = useRef<HTMLDivElement>(null!);

  return (
    <div
      className={classNames(styles.card, {
        [styles.isSelected]: isSelected,
      })}
      ref={ref}
    >
      <img src={imageUrl} alt={name} />
    </div>
  );
};
